import React, { useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import { animate, createScope, stagger } from 'animejs';

export default function SuspenseLoader(){
  const root = useRef(null);
  const scopeRef = useRef(null);

  useEffect(()=>{
    scopeRef.current = createScope({ root })
      .add(() => {
        // animate the dots in a staggered loop
        const rootEl = root.current;
        const targets = rootEl ? rootEl.querySelectorAll('.suspense-dot') : [];
        if (!targets || targets.length === 0) return;
        animate(targets, {
          translateY: [-10, 0],
          scale: [0.85, 1],
          opacity: [0.25, 1],
          easing: 'easeOutSine',
          duration: 650,
          delay: stagger(120),
          loop: true,
          direction: 'alternate',
        });
      });
    return ()=>{ scopeRef.current?.dispose?.(); };
  }, []);

  return (
    <Box
      ref={root}
      role="status"
      aria-live="polite"
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1400,
        pointerEvents: 'none',
      }}
    >
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }} aria-hidden>
        <Box component='span' className='suspense-dot' sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: 'primary.main', display: 'inline-block' }} />
        <Box component='span' className='suspense-dot' sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: 'primary.main', display: 'inline-block' }} />
        <Box component='span' className='suspense-dot' sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: 'primary.main', display: 'inline-block' }} />
        <Box component='span' className='suspense-dot' sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: 'primary.main', display: 'inline-block' }} />
      </Box>
      <Box component='span' sx={{ position: 'absolute', width: 1, height: 1, left: -9999, top: 'auto', overflow: 'hidden' }}>Ładowanie…</Box>
    </Box>
  );
}
